import React from 'react';

export type Slot = React.JSX.Element | string | undefined;

export type Override<Target, Source extends Partial<Record<keyof Target, any>>> = Omit<Target, keyof Source> & Source;

export type UppercaseConstraint<T extends string> = [T] extends [Uppercase<T>] ? T : never;

export type UppercaseTupleConstraint<T extends readonly string[]> = T extends readonly [infer F, ...infer R]
    ? F extends string
        ? [F] extends [Uppercase<F>]
            ? R extends readonly string[]
                ? readonly [F, ...UppercaseTupleConstraint<readonly [...R]>]
                : never
            : never
        : never
    : readonly [];

export const invariant: (condition: boolean, message: string) => asserts condition = (condition, message) => {
    if (!condition) {
        throw new Error(message);
    }
};

export type IntersectionOf<T> = (T extends any ? (t: T) => any : never) extends (i: infer I) => any ? I : never;

export type Pretty<T> = {[K in keyof T]: T[K]} & {};

export type Join<T> = Pick<T, keyof T>;

export type Merged<A, B> = Omit<A, keyof B> & B;

export type Renamed<T, R extends Partial<Record<keyof T, string>>> = {
    [K in keyof T as R[K] extends {} ? R[K] : K]: T[K];
};
